import { getOptionLabel, utilityTunnelDepartments } from "common/enums";
import moment from "moment";
import * as Yup from "yup";

const complainantDetailsSchema = Yup.object({
  complainantDetails: Yup.object({
    utilityConsumerId: Yup.number()
      .required("Please select consumer number")
      .min(0.01, "Please select consumer number"),
    consumerName: Yup.string().required("Complainant Name is required"),
    address: Yup.string().required("Complainant Address is required"),
    pinCode: Yup.string()
      .matches(/^\d{6}$/, "Please enter valid pincode")
      .required("Pincode is required"),
    mobileNumber: Yup.string()
      .matches(/^\d{10}$/, "Please enter valid mobile number")
      .required("Mobile number is required"),
    faxNo: Yup.string()
      .notRequired()
      .matches(/^[0-9+\-\s.]{7,}$/, "Fax Number is not valid"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Email is required"),
    distributionLicensee: Yup.string().required(
      "Distribution Licensee is required"
    ),
  }),
});

const complainDetailsSchema = Yup.object({
  complainDetails: Yup.object({
    grievanceCategoryName: Yup.array().min(
      1,
      "Category of grievance is required"
    ),
    otherCategory: Yup.string().test(
      "isOtherCategoryRequired",
      "",
      function () {
        const [{ value: current }] = this.from || [];
        const isOtherSelected = current.grievanceCategoryName?.find(
          (item) => item.value === 0
        );
        if (isOtherSelected && !current.otherCategory) {
          return this.createError({
            message: "Other Category Name is required",
          });
        }
        return true;
      }
    ),
    employeeName: Yup.string().required("Employee Name is required"),
    complaintDetails: Yup.string().required("Complaint details is required"),
    reliefNature: Yup.string().required("Nature of relief sought is required"),
    documents: Yup.array().optional(),
  }),
});

const otherDetailsSchema = Yup.object({
  otherDetails: Yup.object({
    declaration: Yup.boolean().test(
      "declaration",
      "* Please accept the terms and conditions",
      (value) => value === true
    ),
    isNomineeAdded: Yup.boolean(),
    nomineeName: Yup.string().test("isNomineeNameRequired", "", function () {
      const [{ value: current }] = this.from || [];
      if (current.isNomineeAdded && !current.nomineeName) {
        return this.createError({
          message: "Nominee Name is required",
        });
      }
      return true;
    }),
    nomineeAddress: Yup.string().test(
      "isNomineeAddressRequired",
      "",
      function () {
        const [{ value: current }] = this.from || [];
        if (current.isNomineeAdded && !current.nomineeName) {
          return this.createError({
            message: "Nominee Address is required",
          });
        }
        return true;
      }
    ),
  }),
});

export const getCGRFApplicationSchema = {
  0: complainantDetailsSchema,
  1: complainDetailsSchema,
  2: otherDetailsSchema,
};
